import type { CourseModel } from 'Courses/data';
import {
  deleteFreshStartDesktop,
  deleteMyDesktop,
  deleteParticipantDesktop,
  stopFreshStartDesktop,
  stopMyDesktop,
  stopParticipantDesktop,
  stopTrainerDesktop
} from 'Courses/data';
import { useAppDispatch } from 'Store';
import type { UserDisplayModel } from 'User/userDisplayModel';

import type { DesktopModel } from 'Api';

export interface DesktopActionParams {
  course: CourseModel;
  user: UserDisplayModel;
  desktop: DesktopModel;
  isFreshStartDesktop: boolean;
  isParticipantDesktop: boolean;
  isTrainerDesktop: boolean;
}

export const useDesktopActions = () => {
  const dispatch = useAppDispatch();

  const stopMachine = ({
    course,
    user,
    desktop,
    isFreshStartDesktop,
    isParticipantDesktop,
    isTrainerDesktop
  }: DesktopActionParams) => {
    if (!desktop.instanceId) {
      return;
    }

    if (isFreshStartDesktop) {
      dispatch(
        stopFreshStartDesktop({
          courseId: course.id,
          desktopInstanceId: desktop.instanceId
        })
      );
    } else if (isParticipantDesktop) {
      dispatch(
        stopParticipantDesktop({
          courseId: course.id,
          desktopInstanceId: desktop.instanceId,
          participantId: user.id as string
        })
      );
    } else if (isTrainerDesktop) {
      dispatch(
        stopTrainerDesktop({
          courseId: course.id,
          desktopInstanceId: desktop.instanceId
        })
      );
    } else {
      dispatch(
        stopMyDesktop({
          courseId: course.id,
          desktopInstanceId: desktop.instanceId
        })
      );
    }
  };

  const removeMachine = ({
    course,
    user,
    desktop,
    isFreshStartDesktop,
    isParticipantDesktop
  }: DesktopActionParams) => {
    if (isFreshStartDesktop) {
      dispatch(
        deleteFreshStartDesktop({
          courseId: course.id
        })
      );
    } else if (isParticipantDesktop) {
      if (!desktop.instanceId) {
        return;
      }

      dispatch(
        deleteParticipantDesktop({
          courseId: course.id,
          desktopInstanceId: desktop.instanceId,
          participantId: user.id as string
        })
      );
    } else {
      if (!desktop.instanceId) {
        return;
      }

      dispatch(
        deleteMyDesktop({
          courseId: course.id,
          instanceId: desktop.instanceId
        })
      );
    }
  };

  return { stopMachine, removeMachine };
};
